import React, { memo } from 'react';

import scss from './MessageInfoModal.module.scss';

const EditItem = ({ updatedOn, updatedBy, message }) => {
  return (
    <div className={scss.editItemWrapper}>
      <div className={scss.editDataBlock}>
        <span>{updatedOn}</span>
        <span>{updatedBy}</span>
      </div>

      <pre className={scss.messageText}>{message}</pre>
    </div>
  );
};

export default memo(EditItem);
